import React from "react";
import Banner from "../assets/img/masthead/banner.png";
import RunningGuy from "../assets/img/general/aboutus.png";
import Booking from "../assets/img/icons/booking.png";
import Dashboard from "../assets/img/icons/dashboard.png";
import Rating from "../assets/img/icons/rating.png";
import Calendar from "../assets/img/icons/calendar.png";
import Wishlist from "../assets/img/icons/wishlist.png";
import GroupPhoto from "../assets/img/general/aboutus2.png";
import Listing from "../assets/img/icons/listing.png";
import Management from "../assets/img/icons/management.png";
import Promotion from "../assets/img/icons/promotion.png";
import Insights from "../assets/img/icons/insights.png";
import Feedback from "../assets/img/icons/feedback.png";
import Sponsor from "../assets/img/icons/sponsor.png";
import Vision from "../assets/img/general/vision.png";
import Mission from "../assets/img/general/mission.png";
import CtaBg from "../assets/img/general/cta-bg.png";
import Pattern from "../assets/img/icons/pattern.png";

const AboutUs = () => {
  return (
    <section style={{ marginTop: "80px" }}>
      <section class="masthead -type-1 z-5">
        <div class="masthead__bg">
          <img alt="banner" src={Banner} class="js-lazy" />
        </div>
        <div class="container">
          <div class="row justify-center">
            <div class="col-auto">
              <div class="text-center">
                <h1 class="text-40 lg:text-40 md:text-30 text-white">
                  Your Ultimate Marathon and Sports Event Management Platform
                </h1>
                <p class="mt-20 text-22 lh-14 text-white fw-500 font-nunito">
                  Fitizen India offers a one-stop solution for organizers with
                  hassle-free listing, management, and promotion of marathons
                  and sports events. Fitness enthusiasts can discover, register,
                  and track their progress towards achieving their fitness
                  goals. Join the Fitizen community today!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="layout-pt-md relative">
        <img
          src={Pattern}
          alt="pattern"
          class="absolute"
          width="430"
          style={{ top: 0, left: "-240px", zIndex: -1 }}
        />
        <div class="container">
          <div class="abt-card shadow-2 rounded-16 px-30 lg:px-10 py-40 bg-white">
            <div class="row y-gap-30 justify-between items-center">
              <div class="col-lg-6">
                <h4 class="text-18 fw-600">For Fitness Enthusiasts</h4>
                <h2 class="text-24 fw-700 text-primary mt-10">
                  Discover, Track, and Register for Events
                </h2>
                <p class="text-dark-1 text-16 fw-500 mt-10 lg:mt-10 md:mt-10 font-nunito text-justify">
                  Fitness enthusiasts can effortlessly find, track, and register
                  for events on Fitizen India. Our platform helps you pursue
                  your fitness goals by connecting you with marathons and sports
                  events tailored to your interests.
                </p>
              </div>
              <div class="col-lg-6">
                <img src={RunningGuy} alt="aboutus" class="rounded-8" />
              </div>
            </div>
            <div
              class="mt-40 mb-40"
              style={{ border: "1px dashed lightgrey" }}
            ></div>
            <div class="row y-gap-40 justify-center">
              <div
                data-anim-child="slide-up delay-2"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Booking}
                      alt="booking"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Secure Booking</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Easily and securely register for your desired events
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-1"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Dashboard}
                      alt="dashboard"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600 ">Personalized Dashboard</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Track your event participation, progress, and goals
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Rating}
                      alt="rating"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Ratings & Reviews</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Share your experiences and help others discover amazing
                      events
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Calendar}
                      alt="calendar"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Event Calendar</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Stay organized and plan your fitness journey with our
                      event calendar
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Wishlist}
                      alt="wishlist"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Wishlist</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Save your favorite events for later and never miss an
                      opportunity
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src={Pattern}
          alt="pattern"
          class="absolute"
          width="430"
          style={{ bottom: "220px", right: "-180px", zIndex: -1 }}
        />
      </section>
      <section class="layout-pt-md layout-pb-md relative">
        <img
          src={Pattern}
          alt="pattern"
          class="absolute"
          width="560"
          style={{ top: "40%", left: "-100px", zIndex: -1 }}
        />
        <div class="container">
          <div
            class="abt-card shadow-2 rounded-16 px-30 lg:px-10 py-40 bg-white relative"
            style={{ zIndex: 2 }}
          >
            <div class="row y-gap-30 justify-between items-center">
              <div class="col-lg-6">
                <img src={GroupPhoto} alt="aboutus2" class="rounded-8" />
              </div>
              <div class="col-lg-6">
                <h4 class="text-18 fw-600">For Organizers</h4>
                <h2 class="text-24 fw-700 text-primary mt-10">
                  Seamless Event Listing, Management, and Promotion
                </h2>
                <p class="text-dark-1 text-16 fw-500 mt-10 lg:mt-10 md:mt-10 font-nunito text-justify">
                  Fitizen India provides a comprehensive solution for organizers
                  with hassle-free listing, management, and promotion of
                  marathons and sports events. Our platform simplifies the
                  process, allowing you to focus on delivering exceptional
                  events.
                </p>
              </div>
            </div>
            <div
              class="mt-40 mb-40"
              style={{ border: "1px dashed lightgrey" }}
            ></div>
            <div class="row y-gap-40 justify-center">
              <div
                data-anim-child="slide-up delay-2"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Listing}
                      alt="listing"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Free Event Listing</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Showcase your event to a wider audience at no cost
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-1"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Management}
                      alt="management"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">
                      Comprehensive Event Management
                    </h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Efficiently manage participant data track registrations,
                      and streamline event operations
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Promotion}
                      alt="promotion"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Robust Promotion Tool</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Utilize our platform to effectively market and promote
                      your event
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Insights}
                      alt="insights"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Data-Driven Insights</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Make informed decisions with in-depth analytics on
                      participant behavior and event performance.
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Feedback}
                      alt="feedback"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Feedback Management</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Collect and analyze participant feedback to improve future
                      events
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-anim-child="slide-up delay-4"
                class="col-lg-4 col-sm-6 is-in-view"
              >
                <div class="featureIcon -type-1 ">
                  <div class="d-flex justify-center">
                    <img
                      src={Sponsor}
                      alt="sponsor"
                      class="js-lazy loaded"
                      data-ll-status="loaded"
                    />
                  </div>
                  <div class="text-center mt-30">
                    <h4 class="text-18 fw-600">Sponsorship Assistance</h4>
                    <p class="text-14 mt-10 fw-500 font-nunito">
                      Identify and engage potential sponsors to enhance your
                      event's success
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src={Pattern}
          alt="pattern"
          class="absolute"
          width="560"
          style={{ bottom: "-30%", right: "-180px", zIndex: 1 }}
        />
      </section>
      <section class="layout-pt-md layout-pb-md bg-light-4 relative">
        <div class="container">
          <div class="row y-gap-30 justify-between items-center pb-30 lg:px-10">
            <div class="col-lg-7">
              <img src={Vision} alt="vision" class="rounded-16" />
            </div>
            <div class="col-lg-5">
              <h2 class="text-24 fw-700 text-primary mt-10">
                Our Vision for a Healthier India
              </h2>
              <p class="text-dark-1 text-14 fw-500 mt-10 lg:mt-10 md:mt-10 font-nunito text-justify">
                At Fitizen India, our vision is to build a vibrant community
                where fitness and sports events are accessible to everyone. We
                aim to raise fitness awareness and participation among Indian
                citizens through sustainable, active communities both online and
                offline. By offering an all-in-one platform, we simplify the
                process of engaging in fitness activities, helping people
                achieve their health and wellness goals.
              </p>
            </div>
          </div>
          <div class="row y-gap-30 justify-between items-center pt-30 lg:px-10">
            <div class="col-lg-5">
              <h2 class="text-24 fw-700 text-primary mt-10">
                Connecting Organizers and Fitness Enthusiasts
              </h2>
              <p class="text-dark-1 text-14 fw-500 mt-10 lg:mt-10 md:mt-10 font-nunito text-justify">
                Fitizen India's mission is to bridge the gap between event
                organizers and participants, delivering a seamless and rewarding
                experience for both. We support organizers with the essential
                tools and resources needed to host successful marathon and
                sports events. For fitness enthusiasts, we provide a variety of
                options to stay active and healthy, making it easy to find,
                track, and register for events near them. Through our platform,
                we promote a culture of fitness and well-being across India.
              </p>
            </div>
            <div class="col-lg-7">
              <img src={Mission} alt="mission" class="rounded-16" />
            </div>
          </div>
        </div>
        <img
          src={Pattern}
          alt="pattern"
          class="absolute"
          width="600"
          style={{ top: "33%", left: "-150px", zIndex: 1 }}
        />
      </section>
      <section class="section-bg layout-pt-md layout-pb-sm">
        <div class="container">
          <div class="section-bg__item" data-parallax="0.7">
            <div class="rounded-22 overflow-hidden">
              <img src={CtaBg} alt="cta" />
            </div>
            <div
              class="ctaCard row items-end px-30 lg:px-20 absolute top-0 bottom-0"
              style={{
                background:
                  "linear-gradient(1deg, rgb(0 0 0 / 86%) 0%, #000000bf 50%)",
                width: "100%",
                height: "100%",
              }}
            >
              <div class="col-lg-12 text-center lg:px-0 px-80 py-40 lg:py-0">
                <div class="text-white mt-20 lg:mt-0 text-16 lh-14">
                  Become part of Fitizen India's vibrant community of organizers
                  and fitness enthusiasts. Together, we make fitness events more
                  accessible and engaging.
                </div>
                <div class="d-inline-block mt-20 lg:mt-10">
                  <a
                    href="/about-us"
                    class="button -md -grey-1 bg-primary text-white rounded-25"
                  >
                    Join the event
                  </a>
                </div>
                <div class="text-12 text-white mt-20 lg:mt-10">
                  Growing Fitizen Community
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default AboutUs;
